import { State } from '@/app/state/model';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { selectBTaxAccount } from '../../../state/entities/account/btax-account.selectors';

@Component({
    selector: 'btax-account-balance',
    template: `
        <ng-container *ngIf="due$ | async as due; else amountPlaceholder">
            <ng-container *ngIf="due.total; else nothingDue">
                <div class="total">{{ due.total | currency }} due</div>
                <div class="years">{{ due.years }} {{ due.years === 1 ? "year" : "years" }}</div>
            </ng-container>
            <ng-template #nothingDue>
                <span class="unimportant-text">All paid</span>
            </ng-template>
        </ng-container>
        <ng-template #amountPlaceholder>
            <egov-text-ui-placeholder class="unimportant-text">All paid</egov-text-ui-placeholder>
        </ng-template>
    `,
    styleUrls: ['./account-balance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountBalanceComponent
{
    constructor
    (
        // Dependencies

        private readonly store: Store<State>,
    )
    {}

    @Input() protected set accountNumber(aN: string | undefined) { this.accountNumber$.next(aN); }
    private readonly accountNumber$ = new BehaviorSubject<string | undefined>(undefined);


    // Account data

    private readonly account$ = this.accountNumber$.pipe(
        switchMap(aN => this.store.select(selectBTaxAccount(aN)))
    );

    protected readonly due$ = this.account$.pipe(map(a => a?.due));
}
